import { useQuery } from 'react-query'
import { MessageTemplatesService } from 'src/services/message-templates.service'

export const useCalendarsWithTemplates = () => {
  return useQuery({
    queryKey: ['calendars-with-templates'],
    queryFn: () => MessageTemplatesService.listCalendarsWithTemplates(),
    cacheTime: 0,
    staleTime: 0,
  })
}
